const PRIMARY_API_KEY = process.env.REACT_APP_APIKEY;

// Use Netlify Functions for production, local server for development
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/.netlify/functions' // Netlify Functions
  : 'http://localhost:3001/api';

// Helper function to build URLs for different environments
const buildUrl = (endpoint) => {
  if (process.env.NODE_ENV === 'production') {
    // For production, use Netlify Functions
    return `${API_BASE_URL}/${endpoint}`;
  } else {
    // For development, use the local server
    return `${API_BASE_URL}/${endpoint}`;
  }
};

export const CoinList = (currency, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`coins?currency=${currency}`);

export const SingleCoin = (id, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`coin?id=${id}`);

export const HistoricalChart = (
  id,
  days = 365,
  currency,
  apiKey = PRIMARY_API_KEY
) =>
  buildUrl(`market-chart?id=${id}&vs_currency=${currency}&days=${days}`);

export const TrendingCoins = (currency, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`coins?currency=${currency}&trending=true`);

export const SearchCoin = (query, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`search?query=${query}`);

// New endpoints for professional trading data
export const GlobalData = (apiKey = PRIMARY_API_KEY) =>
  buildUrl('global');

export const CoinMarketData = (id, currency, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`market-chart?id=${id}&vs_currency=${currency}&days=200&interval=daily`);

export const ExchangeRates = (apiKey = PRIMARY_API_KEY) =>
  buildUrl('exchange-rates');

export const CoinOHLC = (id, currency, days, apiKey = PRIMARY_API_KEY) =>
  buildUrl(`market-chart?id=${id}&vs_currency=${currency}&days=${days}&ohlc=true`);
